import React from "react";
import UsersListPanel from "./UsersListPanel";
import Modal from "./UsersModal";
import useUsersLoad from "./useUsersLoad";
import Select from "./UsersSelect";
import Swal from "sweetalert2";
import { Button, Form, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahKorwil, getAllKorwil, getAllClient } from "stores";
import { penempatanKorwil } from "stores";
import { editStatusKorwil } from "stores";
import { resetPassword } from "stores";

function ListKorwil() {
  const dispatch = useDispatch();
  const listState = useUsersLoad(getAllKorwil, dispatch);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const korwil = useSelector((state) => state.korwilReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const auth = useSelector((state) => state.authReducer);

  const [modalKorwil, setModalKorwil] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [nik, setNik] = React.useState("");
  const [role, setRole] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [pilihClient, setPilihClient] = React.useState(null);
  const [listKorwil, setListKorwil] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [idKoordinatorWilayah, setIdKoordinatorWilayah] = React.useState("");
  const [filterClient, setFilterClient] = React.useState([]);
  const [status, setStatus] = React.useState("");

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const hasilFilterClient = (idClient) => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    let tmpFilter = listClient.filter((currentValue, index, arr) => {
      return currentValue.value === idClient;
    });
    tmp.push(tmpFilter[0]);
    setFilterClient(tmp);
  };

  const submitKorwil = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahKorwil({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllKorwil(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusKorwil({
      idKorwil: idKoordinatorWilayah,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllKorwil(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (!pilihClient?.value) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Client tidak boleh kosong",
      });
    } else {
      // const selectedCities = multipleSelect.map((option) => option.value);
      penempatanKorwil({
        idKoordinatorWilayah: idKoordinatorWilayah,
        idClient: idClient,
        // selectedCities: selectedCities
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setModalPenempatan(false);
          // setIdClient("");
          // setPilihClient("");
          getAllKorwil(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihClient(null);
    setModalKorwil(false);
    setModalPenempatan(false);
    setIdClient("");
    setPilihClient(null);
    setNik("");
    setNopeg("");
    setNama("");
  };

  // const submitResetPassword = async (data) => {
  //   try {
  //     const response = await resetPassword({
  //       idUser: data.idUser,
  //       role: data.role,
  //     });

  //     Swal.fire({
  //       title: "Sukses",
  //       text: response.data.message,
  //       icon: "success",
  //     });
  //   } catch (error) {
  //     Swal.fire({
  //       title: "Error",
  //       text: error.response.data.message,
  //       icon: "error",
  //     });
  //   }
  // };

  React.useEffect(() => {
    let tmp =
      korwil.listKorwil &&
      korwil.listKorwil.map((val) => {
        return {
          ...val,
          action: (
            <>
              <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Penempatan Korwil</Tooltip>}
                >
                  <Button aria-label="Penempatan Korwil" title="Penempatan Korwil"
                    disabled={val.status !== "aktif"}
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: val.status !== "aktif" ? "#F1F5F9" : "#EFF6FF",
                      color: val.status !== "aktif" ? "#94A3B8" : "#3B82F6",
                      border: "none",
                      boxShadow: val.status !== "aktif" ? "none" : "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: val.status !== "aktif" ? "not-allowed" : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (val.status === "aktif") {
                        e.currentTarget.style.backgroundColor = "#3B82F6";
                        e.currentTarget.style.color = "#FFFFFF";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (val.status === "aktif") {
                        e.currentTarget.style.backgroundColor = "#EFF6FF";
                        e.currentTarget.style.color = "#3B82F6";
                      }
                    }}
                    onClick={() => {
                      hasilFilterClient(val.idClient);
                      setSelectedUser(val);
                      setIdKoordinatorWilayah(val._id);
                      setPilihClient(null);
                      setIdClient("");
                      getAllClient(dispatch, { idClient: val.idClient });
                      setModalPenempatan(!modalPenempatan);
                    }}
                  >
                    <i className="fas fa-map-marked-alt"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Edit Status</Tooltip>}
                >
                  <Button aria-label="Edit Status" title="Edit Status"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#F1F5F9",
                      color: "#0EA5E9",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#0EA5E9";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#F1F5F9";
                      e.currentTarget.style.color = "#0EA5E9";
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdKoordinatorWilayah(val._id);
                      setStatus("");
                      setModalEdit(true);
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Reset Password</Tooltip>}
                >
                  <Button aria-label="Reset Password" title="Reset Password"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#FEF2F2",
                      color: "#EF4444",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#EF4444";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#FEF2F2";
                      e.currentTarget.style.color = "#EF4444";
                    }}
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Reset Password",
                        text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Ya, Reset Password!",
                      });

                      if (result.isConfirmed) {
                        try {
                          const response = await resetPassword({
                            idUser: val._id,
                            role: val.role,
                          });

                          Swal.fire({
                            title: "Sukses",
                            text: response.data.message,
                            icon: "success",
                          });
                        } catch (error) {
                          Swal.fire({
                            title: "Error",
                            text: error.response.data.message,
                            icon: "error",
                          });
                        }
                      }
                    }}
                  >
                    <i className="fas fa-redo-alt"></i>
                  </Button>
                </OverlayTrigger>
              </div>
            </>
          ),
        };
      });
    setListKorwil(tmp);
  }, [korwil.listKorwil]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          backgroundColor: "#FEE2E2",
          textColor: "#DC2626",
          icon: "fas fa-times-circle"
        };
      case "aktif":
        return {
          backgroundColor: "#DCFCE7",
          textColor: "#16A34A",
          icon: "fas fa-check-circle"
        };
      default:
        return {
          backgroundColor: "#F1F5F9",
          textColor: "#64748B",
          icon: "fas fa-info-circle"
        };
    }
  };

  const colKorwil = [
    {
      name: "No",
      width: "80px",
      center: true,
      selector: (row, index) => index + 1,
    },
    {
      name: "Kode User",
      minWidth: "150px",
      center: true,
      selector: (row) => row.kodeUser,
    },
    {
      name: "No Karyawan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.role === "koordinator wilayah"
          ? "Koordinator Wilayah"
          : "Koordinator Wilayah",
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      // omit: true,
      selector: (row) =>
        !row.penempatan?.length
          ? "Belum Penempatan"
          : row.penempatan?.[0]?.namaClient?.namaClient || "Belum Penempatan",
    },
    {
      name: "Status",
      minWidth: "150px",
      center: true,
      // selector: (row) => (row.status === "aktif" ? "Aktif" : "Tidak Aktif"),
      selector: (row) => row.status,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const tampilanLabel = row.status === "aktif" ? "Aktif" : "Tidak Aktif";

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "600",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
            }}
          >
            <i className={statusStyle.icon}></i>
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "250px",
      center: true,
      omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => { getAllClient(dispatch); }, [dispatch]);

  return (
    <>
      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#EFF6FF", padding: "8px", borderRadius: "10px", color: "#3B82F6", display: "flex" }}>
                <i className="fas fa-map-marker-alt"></i>
              </div>
              Penempatan Koordinator Wilayah
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalPenempatan(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Client (BPD)</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihClient}
                  onChange={(value) => {
                    setPilihClient(value);
                    setIdClient(value.value);
                  }}
                  options={filterClient}
                  placeholder="Pilih Client..."
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#3B82F6" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalPenempatan(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitPenempatan}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#3B82F6", border: "none", boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)", color: "white" }}
            >
              Simpan Penempatan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-edit"></i>
              </div>
              Edit Status Korwil
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalEdit(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Status</label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Pilih status aktif/tidak aktif"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#0EA5E9" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalEdit(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              variant="primary"
              onClick={checkStatus}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)" }}
            >
              Simpan Perubahan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <UsersListPanel title="Koordinator Wilayah" description="Pantau akun koordinator dan penempatan BPD."
        data={listKorwil} columns={colKorwil} {...listState}
        addLabel="Tambah Korwil" onAdd={(auth.role === "super admin" || auth.role === "admin") ? () => setModalKorwil(true) : undefined} />

      <Modal
        size="lg"
        show={modalKorwil}
        onHide={() => {
          handleModalClose();
          setModalKorwil(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={null}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-user-plus"></i>
              </div>
              Form Tambah Koordinator Wilayah
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => { handleModalClose(); setModalKorwil(false); }} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>NIK</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Form.Control
                        onChange={handleNikChange}
                        value={nik}
                        type="text"
                        placeholder="Masukkan 16 digit NIK"
                        style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0", flex: 1 }}
                      />
                      <span style={{ fontSize: "12px", fontWeight: "600", color: remainingDigits === 0 ? "#16A34A" : "#94A3B8", backgroundColor: remainingDigits === 0 ? "#DCFCE7" : "#F1F5F9", padding: "4px 8px", borderRadius: "20px" }}>
                        {remainingDigits} digit
                      </span>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Nama Lengkap</label>
                    <Form.Control
                      onChange={(e) => setNama(e.target.value)}
                      placeholder="Masukkan nama lengkap"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={auth.role === "super admin" ? 6 : 12}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>No Karyawan / Username</label>
                    <Form.Control
                      onChange={(e) => setNopeg(e.target.value)}
                      placeholder="Masukkan No Karyawan"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                {auth.role === "super admin" && (
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Client (BPD)</label>
                      <Select
                        classNamePrefix="react-select"
                        value={pilihClient}
                        onChange={(value) => {
                          setPilihClient(value);
                          setIdClient(value.value);
                        }}
                        options={listClient}
                        placeholder="Pilih BPD..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            borderColor: "#E2E8F0",
                            padding: "4px",
                            boxShadow: "none",
                            "&:hover": { borderColor: "#0EA5E9" }
                          })
                        }}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => { handleModalClose(); setModalKorwil(false); }}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitKorwil}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 24px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)" }}
            >
              <i className="fas fa-save mr-2"></i> Simpan Data
            </Button>
          </Modal.Footer>
        </>
      </Modal>
    </>
  );
}

export default ListKorwil;
